import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

export default ({ to, activeClassName, ...rest }) => {
  if (typeof to === 'string') {
    // test to see if url is internal - external urls are rendered as
    // normal anchors
    if (/^\/(?!\/)/.test(to)) {
      return (
        <GatsbyLink
          activeClassName={activeClassName}
          partiallyActive={!to.match(/\/$/)}
          to={to}
          {...rest}
        />
      )
    }
  }

  return <A href={to} isExternal={!!to} {...rest} />
}

const externalProps = {
  target: '_blank',
  rel: 'noopener noreferrer'
}

const A = ({ isExternal = false, children, ...rest }) => (
  <a {...(isExternal ? externalProps : {})} {...rest}>
    {children}
  </a>
)
